// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ExternalLink(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ExternalLink" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M13.4999 3.99996H18.2498L7.99992 14.2499L9.7499 15.9998L19.9998 5.74994V10.9999L22.4998 10.9845L22.4998 1.49998H13.4999V3.99996Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10.9999 3.99996H1.99998V21.9998H19.9998V13.9999H17.4998V19.4998H4.49995V6.49993H10.9999V3.99996Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ExternalLink.js.map